<template>

  <div id="cast" class="section">
    <div class="cast_box">
      <div class="cast_text">

        <div class="logo_wrap">

          <div class="cast_logo"><h1>Cast</h1></div>

          <div class="cast_inside_box">

            <div class="content_box">
              <div class="ereki_content">
                <div class="ereki_photo"></div>
                <div class="ereki_profile">
                  <h2>小林エレキ</h2>
                  <h3 class="align-left">(野沢徹)</h3>
                  <p>
                  北海道・札幌を拠点に活動する俳優、ナレーター、演技講師。
                  「北海道新聞」「札幌大学」「びっくりドンキー」
                  「小笠原クリニック」のTVCMのナレーションや、「まねきねこ」
                  「道銀ラピッド」のTVCMに出演。
                  現在、文化放送で放送中のネオラジオドラマ『三国志』では
                  「劉備玄徳」役として出演中。
                  </p>  
                </div>
              </div>
            </div>
          
              <div class="content_box">
                <div class="kamin_content">
                  <div class="kamin_photo"></div>
                  <div class="kamin_profile">
                    <h2>白波多カミン</h2>
                    <h3 class="align-left">(松井ミカ)</h3>
                    <p>
                    京都出身のシンガーソングライター。
                    小学6年からギターを始め、高校3年から歌を書き始める。
                    2011年にアルバム『ランドセルカバーのゆくえ』でデビュー。
                    2016年メジャーデビューアルバム『空席のサーカス』をリリース。
                    2020年公開の映画『東京バタフライ』では主演を務めた。
                    </p>  
                  </div>
                </div>
            </div>
          </div> <!-- inside -->

          </div> <!-- logo wrap-->

      </div>
    </div>
  </div>
  <div class="cast_bottom"></div>
</template>

<style>

#cast{
  
  /* border: 2px dashed rgb(217, 7, 14);  */
  position: relative;
  display: flex;
  font-family: 'Shippori Mincho', sans-serif;
  display: flex;
  height: auto;
  width:auto;
  margin-bottom: 3vh;
  padding-top: 15vh;
  align-items: center;
  justify-content: center;
}

.cast_box{
  /* border: 2px solid rgb(24, 5, 194);  */
  position: relative;
  display: flex;
  text-align: left;
  padding: 0px;
  width:auto;
  height:auto;
  justify-content: center;
  /* margin-left: 15vw; */
  /* margin-right: 15vw; */


}

.cast_text{
  /* border: 2px dashed rgb(62, 5, 194);  */
  position:relative;
  top:0%;
  padding-right: 0%;
  padding-left: 0vw;
  width:auto;
  height: auto;
  ;
}

.logo_wrap{
  display: block;
  /* border: 2px dashed rgb(5, 194, 21);  */
  width:auto;
  

}

.cast_logo{
  /* border: 2px solid rgb(194, 5, 74);  */
  position:relative;
  top:0%;
  padding-right: 0%;
  padding-left: 0;
  width:auto;
  
  height: auto;
  display: flex;
  justify-content:flex-start;
}

.cast_logo h1{
  /* border: 2px solid rgb(5, 194, 43);  */
  top:0%;
  
  line-height: 1;
  letter-spacing: 0px; 
  /* text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3); */
  font-weight: bolder;
  font-size:calc(32px);
  padding-left: 0vw;
}


.cast_inside_box{
  /* border: 4px solid rgb(5, 159, 194);  */
  width: auto;
  display: flex;
  flex-wrap: wrap;
  margin-top: 1vh;
  /* align-items: center; */
  justify-content: center;
}

.content_box{
  /* border: 3px dashed rgb(191, 5, 194);  */
  padding-left: 0;
  padding-right: 0;
  padding-top: 10px;
  margin: 0;
  width: auto;

  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ereki_content{
  /* border: 4px dashed rgb(8, 5, 194);  */
  align-items: top;
  margin-top: 0vw;
  margin-left:0px;
  margin-right:30px;
  margin-bottom: 3vw;
  padding-right: 0vw; 
  width: auto;
  

}

.kamin_content{
  /* border: 2px dashed rgb(194, 5, 74);  */
  align-items: top;
  margin-top: 0vw;
  margin-left:30px;
  margin-right:0px;
  margin-bottom: 3vw;
  padding-left: 0vw; 
  width: auto;

}


.ereki_photo{
  /* border: 1px solid rgb(13, 0, 255); */
  background-image: url('../assets/Cast1.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height:18vw;
  width:18vw;
  max-width: 320px;  
  max-height: 320px;

  min-width: 200px;
  min-height: 200px;
  
}

.kamin_photo{
  /* border: 1px solid rgb(13, 0, 255); */
  background-image: url('../assets/Cast2.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height:18vw;
  width:18vw;
  max-width: 320px;
  max-height: 320px;

  min-width: 200px;
  min-height: 200px;


}

.ereki_profile{
  /* border: 1px solid rgb(126, 131, 4);  */
  letter-spacing: 0.2px;
  padding-left: 0;
  padding-right: 0;
  font-weight: lighter; 
  font-size: calc(14px); 
  line-height: 1.6;
  width: 18vw;
  height: auto;
  max-width: 320px; 
  min-width: 200px;
  text-align: justify;
  
}

.kamin_profile{
  /* border: 1px solid rgb(126, 131, 4);  */
  letter-spacing: 0.2px;
  padding-left: 0;
  padding-right: 0;
  font-size: calc(14px); 
  line-height: 1.6;
  width: 18vw;
  height: auto;
  max-width: 320px; 
  min-width: 200px;
  text-align: justify;
}



.ereki_profile  h2,h3{
  /* border: 1px solid rgb(34, 0, 255);  */
  font-family: 'Zen Kaku Gothic New', sans-serif;

  line-height: 0.3;
  padding-left: 0px;
  padding-bottom: 6px;
  margin-top: 24px;
  margin-bottom: 12px;
  width: auto;
}

.kamin_profile  h2,h3{
  /* border: 1px solid rgb(34, 0, 255);  */
  font-family: 'Zen Kaku Gothic New', sans-serif;
  line-height: 0.3;
  padding-left: 0px;
  padding-bottom: 6px;
  margin-top: 24px;
  margin-bottom: 12px;
  width: auto;
}


.align-left{
  padding-left: 0px;
  margin-top: 0;
  padding-top: 0;
}


.cast_bottom{
  position: relative;
  /* border: 2px solid rgb(13, 0, 255); */
  background-image: url('../assets/Directors1.jpg');
  background-size:contain;
  background-repeat: no-repeat;

  padding-bottom: 30%;
  padding-left: 0;
  padding-right: 0;
  height: auto;
  width: 100%;
  margin-left: 0;
  
}

@media (max-width: 680px) {

  .cast_text{
    width:70vw;
    margin-left: 3vw;
    margin-right: 3vw;
  }

  .content_box {
    width: auto;
  }
  .ereki_content {
    width: auto;
    margin-right:0vw;
  }

  .kamin_content {
    width: auto;
    margin-left:0vw;
  }

  .kamin_photo{
    width:auto;
    height:60vw;
  }

  .ereki_photo{
    width:auto;
    height:60vw;

  }

  .kamin_profile{
  /* border: 5px solid rgb(246, 255, 0);  */
  letter-spacing: 0.2px;
  padding-left: 0;
  padding-right: 0;
  font-size: calc(14px); 
  line-height: 1.6;
  width: auto;
  height: auto;
  
}
.ereki_profile{
  /* border: 5px solid rgb(246, 255, 0);  */
  letter-spacing: 0.2px;
  padding-left: 0;
  padding-right: 0;
  font-size: calc(14px); 
  line-height: 1.6;
  width: auto;
  height: auto;
  text-align: justify
}

}




</style>